import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';
import 'bootstrap-icons/font/bootstrap-icons.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Default config for Local Development (Fallbacks)
// Replace these with your current DEV environment values so 'npm start' works
const localConfig = {
  // Restore original apiBaseUrl (API Gateway / REST)
  // apiBaseUrl: 'https://89qp46aur6.execute-api.eu-west-1.amazonaws.com/dev',
  // AppSync GraphQL endpoint (local fallback)
  appSyncUrl: 'https://resolveguru-uat-api.dev.srdops.com/graphql',
  cognito: {
    userPoolId: 'eu-west-1_Pytq9ciSP',
    userPoolClientId: '7jlgj1lug1tv9ktmmku2bofipe',
    domain: 'resolveguru-dev.auth.eu-west-1.amazoncognito.com',
    redirectSignIn: 'http://localhost:3000/',
    redirectSignOut: 'http://localhost:3000/'
  }
};

const runApp = async () => {
  let config = localConfig;

  // Try to load config.json generated by CDK (exists in S3/CloudFront, not locally)
  try {
    const response = await fetch('/config.json');
    if (response.ok && response.headers.get('content-type')?.includes('application/json')) {
      const runtimeConfig = await response.json();
      console.log('Loaded runtime config:', runtimeConfig);
      
      // Merge runtime config
      // NOTE: The backend CDK currently exports the AppSync URL under 'apiBaseUrl' in config.json
      config = {
        // Fallback to local REST API Gateway URL because CDK currently puts AppSync in 'apiBaseUrl'
        apiBaseUrl: runtimeConfig.restApiUrl || localConfig.apiBaseUrl,
        // Grab the deployed AppSync URL from 'apiBaseUrl' (where CDK puts it)
        appSyncUrl: runtimeConfig.appSyncUrl || runtimeConfig.apiBaseUrl || localConfig.appSyncUrl,
        cognito: {
          ...runtimeConfig.cognito,
          // Ensure domain doesn't have protocol for Amplify config if CDK sends it
          domain: runtimeConfig.cognito.domain.replace('https://', '') 
        }
      };
    }
  } catch (e) {
    console.log('Using local configuration (config.json not found)');
  }

  // Store config globally for api.js to access
  window.APP_CONFIG = config;

  // Configure Amplify with dynamic values
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.cognito.userPoolId,
        userPoolClientId: config.cognito.userPoolClientId,
        loginWith: {
          oauth: {
            domain: config.cognito.domain,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [config.cognito.redirectSignIn],
            redirectSignOut: [config.cognito.redirectSignOut],
            responseType: 'code',
            providers: ['KONE-AzureAD']
          }
        }
      }
    },
    API: {
      GraphQL: {
        endpoint: config.appSyncUrl,
        region: 'eu-west-1',
        defaultAuthMode: 'userPool'
      }
    }
  });

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

runApp();
